import { useQuery } from '@tanstack/react-query';

import { RequestAccessAPI } from '../index';
import { TRANSLATION_NAMESPACE } from '../../constants';

const useFetchTranslations = (language?: string) => {
    const { data, isLoading, error } = useQuery({
        queryKey: [TRANSLATION_NAMESPACE, language],
        queryFn: () => RequestAccessAPI.fetchTranslations(language as string), // it is guaranteed that language is defined because react-query is not running the query if language is undefined due to the enabled property
        enabled: !!language,
    });

    return {
        isLoading,
        error,
        data,
    };
};

export { useFetchTranslations };
